import React, { useState, useEffect, useRef } from "react";
import { appNotificationCollection } from "../../../components/firebase/DataProvider";
import { date } from "../../../utils/dateTime";
import Skeleton from "@material-ui/lab/Skeleton";
import groupBy from "lodash/groupBy";
import IconButton from "@material-ui/core/IconButton";
import VolumeDownIcon from "@material-ui/icons/VolumeDown";
import Divider from "@material-ui/core/Divider";

// Styles
import useStyles from "./styles/ListAlamat";
import { firestore } from "../../../components/firebase/FirebaseProvider";
import { useHistory } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import { Typography } from "@material-ui/core";

function Aplikasi() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(true);

  const [data, setData] = useState([]);
  const history = useHistory();
  const lastVisible = useRef();

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      setData([]);

      const query = await appNotificationCollection
        .orderBy("created_at", "desc")
        .limit(10)
        .get();
      if (!query.empty) {
        const newData = query.docs.map((doc) => {
          return {
            id: doc.id,
            ...doc.data(),
          };
        });
        setData((notifLama) => [...notifLama, ...newData]);

        lastVisible.current = query.docs[query.docs.length - 1];
      }
      setLoading(false);
    }
    fetchData();
  }, []);

  const loadMoreProducts = async () => {
    if (lastVisible.current && loadingMore) {
      setLoadingMore(true);
      try {
        const query = await appNotificationCollection
          .orderBy("created_at", "desc")
          .startAfter(lastVisible.current)
          .limit(10)
          .get();
        if (!query.empty) {
          const newData = query.docs.map((doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          });

          setData((notifLama) => [...notifLama, ...newData]);

          lastVisible.current = query.docs[query.docs.length - 1];
        } else {
          lastVisible.current = null;
          setLoadingMore(false);
        }
      } catch (e) {}
    }
  };

  const handleClick = (item) => async () => {
    switch (item?.data?.target_type) {
      case "kategori3":
        const categoriesCol = firestore.collection("categories");
        const filter = await categoriesCol.doc(item?.data?.target_id).get();
        history.push(
          `/kategori/kategori3/${filter?.data().nama}/${item?.data?.target_id}`
        );
        break;
      case "brand":
        const brandCol = firestore.collection("brand");
        const hasil = await brandCol.doc(item?.data?.target_id).get();
        history.push(
          `/kategori/brand/${hasil?.data().nama}/${item?.data?.target_id}`
        );
        break;
      case "produk":
        // console.log(item?.data?.target_id);
        const productsCol = firestore.collection("products");
        const query = await productsCol.doc(item?.data?.target_id).get();
        history.push(`/produk/${query?.data().nama}/${item?.data?.target_id}`);
        // console.log(query?.data().nama);
        break;
      case "webview":
        window.open(`${item?.data?.target_id}`);
        break;
      default:
        break;
    }
  };

  if (loading) {
    return (
      <div className={classes.contentWrapper}>
        <Skeleton variant="rect" />
      </div>
    );
  }

  const groupDataByDate = groupBy(data, (item) => {
    return date(item.created_at?.toDate?.());
  });

  const sections = Object.entries(groupDataByDate).map(([key, value]) => {
    return {
      title: key,
      data: value,
    };
  });

  return (
    <>
      <InfiniteScroll
        dataLength={data.length}
        style={{ overflow: "hidden", marginBottom: "55px" }}
        next={loadMoreProducts}
        hasMore={loadingMore}
        loader={
          <Typography
            color="primary"
            style={{ textAlign: "center", marginBottom: "20px" }}
          >
            <b>Memuat</b>
          </Typography>
        }
        endMessage={
          <p style={{ textAlign: "center" }}>
            <b>Yay! Kamu Sudah Melihat Semua</b>
          </p>
        }
      >
        {sections.map((item) => (
          <div className={classes.contentWrapper}>
            <div className={classes.head}>
              {/* <div
                style={{
                  backgroundColor: "#DCDCDC",
                  borderRadius: "7px",
                  marginBottom: 15,
                  marginTop: -10,
                }}
              > */}
                <Typography className={classes.title}>{item.title}</Typography>
              {/* </div> */}
            </div>
            {item.data.map((value) => (
              <>
                <div className={classes.body} onClick={handleClick(value)}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                    }}
                  >
                    <IconButton
                      size="small"
                      style={{ backgroundColor: "#5675D3" }}
                    >
                      <VolumeDownIcon style={{ color: "white" }} />
                    </IconButton>
                    <div style={{ width: "100%" }}>
                      <span className={classes.titleBody}>{value.title}</span>
                      <p className={classes.bodyTitle}>{value.message}</p>
                    </div>
                  </div>
                </div>
                <Divider />
              </>
            ))}
          </div>
        ))}
      </InfiniteScroll>
    </>
  );
}

export default Aplikasi;
